import { render, staticRenderFns } from "./ToolbarSettings.vue?vue&type=template&id=8b960c4e&scoped=true"
import script from "./ToolbarSettings.vue?vue&type=script&lang=js"
export * from "./ToolbarSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b960c4e",
  null
  
)

export default component.exports